import { useLayoutEffect, useState } from "react";
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    MenuItem,
    InputLabel,
    Select,
    Grid,
    Typography,
    IconButton,
    Chip,
    Input,
    FormHelperText,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { ERoles } from "../../../../config";

function AddIPstoApikey({ open, handleClose, formik, selectedResellerData, selectedOrgData, roleName, ipAddresses, setIPAddresses }) {
    const [currValue, setCurrValue] = useState(null);
   
     
    const handleChange = (event) => {
        const { value, name } = event.target;
        const maxCharacters = 15; // Max length for IPv4 (e.g., "255.255.255.255")
    
        // Allow only numbers and dots
        const filteredValue = value.replace(/[^0-9.]/g, "");
    
        // IPv4 validation: 0-255.0-255.0-255.0-255
        const isValidIPv4 = (ip) => {
            const octets = ip.split(".");
            if (octets.length !== 4) return false;
            return octets.every((octet) => {
                if (octet === "") return false;
                const num = Number(octet);
                return num >= 0 && num <= 255 && /^[0-9]+$/.test(octet);
            });
        };
    
        if (filteredValue.length > maxCharacters) {
            formik.setFieldError(name, `Only ${maxCharacters} characters are allowed.`);
            return;
        }
    
        if (filteredValue && !isValidIPv4(filteredValue)) {
            formik.setFieldError(name, "Invalid IPv4 Address format.");
        } else {
            formik.setFieldError(name, "");
        }
    
        setCurrValue(filteredValue);
    };
    
    const addIps = () => {
        if (ipAddresses.includes(currValue)) {
            formik.setFieldError("ipAddresses", `IPAddress already exist.`);
            return;
        }
        setIPAddresses([...ipAddresses, currValue]);
        setCurrValue("");
        formik.setFieldError("ipAddresses", ``);
    };

    const onClickInheritIPAddress = () => {
        setIPAddresses(roleName === ERoles.SUPER_ADMIN ? selectedResellerData?.ipAddresses : selectedOrgData?.ipAddresses);
    };

    const handleDelete = (item, index) => {
        let arr = [...ipAddresses];
        arr.splice(index, 1);
        setIPAddresses(arr);
    };

    const onClickHandleSubmit = () => {
        setIPAddresses(ipAddresses);
        handleClose();
    };

    const handClear = () => {
        setIPAddresses([]);
        handleClose();
    };

    return (
        <>
            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h5"> Add IP Addresses</Typography>
                    <IconButton onClick={() => handleClose()}>
                        <CloseOutlined />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent
                    sx={{
                        overflowY: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        gap: "30px",
                        width: "500px",
                    }}
                >
                    <Grid>
                        <Button
                            variant="outlined"
                            color="primary"
                            disabled={formik.values.ipAddresses && formik.values.ipAddresses.length <= 0}
                            onClick={onClickInheritIPAddress}
                        >
                            Inherit IPs from {roleName === ERoles.SUPER_ADMIN ? selectedResellerData?.resellerName : selectedOrgData?.orgName}
                        </Button>
                    </Grid>
                    <Grid item padding={2} md={6}>
                        <Typography className="text-muted mb-2">IP Address should be 15 characters.</Typography>

                        <div>
                            {ipAddresses &&
                                ipAddresses.length > 0 &&
                                ipAddresses?.map((item, index) => (
                                    <Chip
                                        size="small"
                                        onDelete={() => {
                                            handleDelete(item, index);
                                        }}
                                        label={item}
                                        sx={{ margin: "4px" }}
                                    />
                                ))}
                        </div>
                        <FormControl error={formik.errors?.ipAddresses}>
                            <Grid>
                                <Input value={currValue} onChange={handleChange} placeholder="0.0.0.0"/>

                                <IconButton onClick={addIps} disabled={!currValue}>
                                    <AddIcon />
                                </IconButton>
                            </Grid>
                            <FormHelperText>{formik.errors?.ipAddresses}</FormHelperText>
                        </FormControl>
                    </Grid>
                </DialogContent>

                <DialogActions
                    style={{
                        padding: "1rem 1.5rem",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: ".25rem",
                    }}
                >
                    <Button variant="contained" color="error" onClick={handClear}>
                        Clear
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => onClickHandleSubmit()}
                        autoFocus
                        disabled={ipAddresses && ipAddresses.length <= 0}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default AddIPstoApikey;
